export const subtitles = {
    "1": {
        "startTime": 1.52,
        "endTime": 5.04,
        "transcript": "Akiutamek kitak' tegulluten 25 ayagcessgu.",
        "translation": "Take $25 and send it."
    },
    "2": {
        "startTime": 5.04,
        "endTime": 10.95,
        "transcript": "[?] ciumek, tuar tang una elder-aarunrilnguq.",
        "translation": "[?] first, this one doesn't seem like an elder."
    },
    "3": {
        "startTime": 11.92,
        "endTime": 14.07,
        "transcript": "Iliini pilaraatnga...",
        "translation": "Sometimes, they say to me..."
    },
    "4": {
        "startTime": 14.31,
        "endTime": 15.85,
        "transcript": "Where's your mom? Ai?",
        "translation": "Where's your mom? What?"
    },
    "5": {
        "startTime": 15.855,
        "endTime": 17.155,
        "transcript": "Nauwa-m' akiliutaq?",
        "translation": "Where's the payment?"
    },
    "6": {
        "startTime": 19.53,
        "endTime": 20.26,
        "transcript": "Wait.",
        "translation": "Wait."
    },
    "7": {
        "startTime": 20.89,
        "endTime": 21.89,
        "transcript": "Okay.",
        "translation": "Okay."
    },
    "8": {
        "startTime": 23.155,
        "endTime": 28.035,
        "transcript": "Qaillun wanigg' aulukesterpet wanigg' cucukelallruaki wanigg' uikan?",
        "translation": "Now, how did your caretakers choose your husband?"
    },
    "9": {
        "startTime": 28.87,
        "endTime": 38.36,
        "transcript": "Aulukesteḿa uingevkallruanga wiinga piyulqenrit[lemnek]. Iciw' wiinga pick-allrunritua uikamnek.",
        "translation": "My caretaker had me take a husband that I didn't choose. You know, I didn't pick my own husband."
    },
    "10": {
        "startTime": 39.39,
        "endTime": 42.43,
        "transcript": "Qaillun cucukilallruat?",
        "translation": "How did they choose?"
    },
    "11": {
        "startTime": 42.9,
        "endTime": 50.962,
        "transcript": "Cucukilallruut-gguq parent-aarit, angayuqrit qalarulluteng irniateng.",
        "translation": "They said the way they chose was their parents would speak to each other about their children."
    },
    "12": {
        "startTime": 51.338,
        "endTime": 58.8,
        "transcript": "Panini uikaanek, qetunrani nulirkaanek paren-aarit-gguq cucuklilallruut.",
        "translation": "They said their parents would choose their daughters' husbands, their son's wives."
    },
    "13": {
        "startTime": 60.113,
        "endTime": 69.738,
        "transcript": "Taukut wanigg' amlleraqameng wanigg' cucukestai, naliaggun ayuquciaggun-qaa tangssugluki pilallruai?",
        "translation": "When there were a lot of suitors, would they look at their characters?"
    },
    "14": {
        "startTime": 69.757,
        "endTime": 83.069,
        "transcript": "Yaa, angayuqrita-gguq yuut ayuqenrilata cucukek'meggnek paniteng uikaitnek cucukilallruut.",
        "translation": "Yes, they said that because people are different, their parents would choose the husband they preferred for their daughters."
    },
    "15": {
        "startTime": 86.97,
        "endTime": 93.582,
        "transcript": "Elpet-qaa qaneryuunak piurluten, kiingan maligtaqulluten?",
        "translation": "Did you say nothing, only obeyed?"
    },
    "16": {
        "startTime": 93.595,
        "endTime": 106.295,
        "transcript": "Yaa, tamaani-gguq, tamaani ayagyuat tan'gaurluut nasaurluut-llu aipaqutaayuitellruut.",
        "translation": "Yes, they said that back then, the young people, boys and girls, wouldn't play with each other."
    },
    "17": {
        "startTime": 106.302,
        "endTime": 116.177,
        "transcript": "Aipaqutaayuitellruut-gguq kenkucuunateng-llu. Iciw' takaitevkenateng. Takaryutuluteng.",
        "translation": "They said that they didn't play with each other and didn't get into relationships. You know, they weren't too forward. They were respectful."
    },
    "18": {
        "startTime": 116.346,
        "endTime": 121.071,
        "transcript": "Tass'uqluteng-llu tarricuunateng maa-i-cetun.",
        "translation": "And they wouldn't walk around holding hands like they do now."
    },
    "19": {
        "startTime": 122.352,
        "endTime": 131.352,
        "transcript": "Qaillun wanigg' assirluten wife-auyugngasit, uilguyugngasit?",
        "translation": "How can you be a good wife, one with a husband?"
    },
    "20": {
        "startTime": 131.471,
        "endTime": 133.059,
        "transcript": "Nulirruyugngasia?",
        "translation": "How I can be a wife?"
    },
    "21": {
        "startTime": 133.072,
        "endTime": 134.209,
        "transcript": "Stop.",
        "translation": "Stop."
    },
    "22": {
        "startTime": 134.222,
        "endTime": 137.897,
        "transcript": "Qaillun wanigg' assirluten nulirrauyugngasit?",
        "translation": "How can you be a good wife?"
    },
    "23": {
        "startTime": 138.103,
        "endTime": 149.966,
        "transcript": "Assirluteng-gguq nulirruyugngalriit aipateng, uiteng qigcik'lallruit, takaqluki.",
        "translation": "They said that those who could be good wifes would respect and defer to their spouses, their husbands."
    },
    "24": {
        "startTime": 150.078,
        "endTime": 162.141,
        "transcript": "Uini-llu-gguq-qaa arnam kegginaa assiilengraan uikekuniu qigcikluku, takaqluku uikeciqaa",
        "translation": "They also said that if a woman takes a husband even if he has an ugly face, she will treat her husband with respect and deference."
    },
    "25": {
        "startTime": 162.153,
        "endTime": 164.903,
        "transcript": "Caunrilkevkenaku.",
        "translation": "Not disparaging him"
    },
    "26": {
        "startTime": 170.897,
        "endTime": 172.847,
        "transcript": "Qaillun cali?",
        "translation": "What else?"
    },
    "27": {
        "startTime": 177.579,
        "endTime": 187.704,
        "transcript": "Tua-i-w' ava-i nulirruyugngalriim assirluni uini takaqluku uikeciqellinia.",
        "translation": "As just now, one who can be a good wife will treat her husband with deference."
    },
    "28": {
        "startTime": 188.335,
        "endTime": 196.16,
        "transcript": "Nalluani-llu qaillukuayuunani, qigcikluku maligtaquurluku.",
        "translation": "And she doesn't mess around without his knowledge, and obeys him out of respect."
    },
    "29": {
        "startTime": 199.704,
        "endTime": 206.529,
        "transcript": "Egmian-qaa neq'liurarluku piuralguluku?",
        "translation": "Should she always prepare food for him?"
    },
    "30": {
        "startTime": 206.548,
        "endTime": 207.56,
        "transcript": "Ii-i.",
        "translation": "Yes."
    },
    "31": {
        "startTime": 207.573,
        "endTime": 208.473,
        "transcript": "Uterpailegmeng-llu-q'?",
        "translation": "And before they go home?"
    },
    "32": {
        "startTime": 208.48,
        "endTime": 218.242,
        "transcript": "Yuilqumtaqata-llu-gguq imumi uiteng utaqauratullruit nulirrita, tekitaqata tau͡gaam ner'aqluteng.",
        "translation": "They also said that when they were in the wilderness a long time ago, their wives would wait for their husbands, only eating when they arrived."
    },
    "33": {
        "startTime": 223.855,
        "endTime": 228.768,
        "transcript": "Camek-qaa cali amani wanigg' arnat calallratnek qanrucugngaarpekut?",
        "translation": "Can you tell us anything about the things women worked on a long time ago?"
    },
    "34": {
        "startTime": 229.855,
        "endTime": 240.48,
        "transcript": "Avani-gguq-qaa ciuqvani arnat maani maa-i watuacetun ayuqellrunritut.",
        "translation": "They said that a long time ago, the women were not like how they are now."
    },
    "35": {
        "startTime": 242.774,
        "endTime": 248.874,
        "transcript": "Tan'gaurlurmek-llu, tan'gaungqessuunateng, takaqulluteng cakneq.",
        "translation": "And boys, they didn't have boys, greatly respecting each other."
    },
    "36": {
        "startTime": 248.881,
        "endTime": 259.368,
        "transcript": "Aquigaqameng-llu-gguq-qaa arnat allakarmeng, yaatiitni-llu allakarmeng angutet aquituluteng, waten ilarqulluteng pivkenateng.",
        "translation": "They also said that when they played, the girls were separate, and the boys played separately over there, not interacting with each other like this."
    },
    "37": {
        "startTime": 259.381,
        "endTime": 268.081,
        "transcript": "Taumek-gguq-qaa qingayuitellrulriit-llu, qingalriit-llu enurnarluteng avani ciuqvani ayagyuat.",
        "translation": "That's why they said they didn't get pregnant, and there were scarce any pregnant young people a long time ago."
    },
    "38": {
        "startTime": 268.525,
        "endTime": 274.988,
        "transcript": "Qaillun tamana ayagningellrungata wanigg' takairulluteng?",
        "translation": "How did that lack of proper social conduct seem to start?"
    },
    "39": {
        "startTime": 275.675,
        "endTime": 284.45,
        "transcript": "Ukaqvaggun tuar tang wiinga murilkellemni elitnaungellemteńi takairusngiinallrulriakut.",
        "translation": "Recent, it seems to me in my observation, that we started lacking proper social conduct when we start going to school."
    },
    "40": {
        "startTime": 284.45,
        "endTime": 292.413,
        "transcript": "Elitnauraqamta wiinga takaryutullruunga elitnaulallemni.",
        "translation": "When we went to school, I would be withdrawn when I went to school."
    },
    "41": {
        "startTime": 292.425,
        "endTime": 294.45,
        "transcript": "Tua-i takarnaqluni.",
        "translation": "It was a place to conduct oneself properly."
    },
    "42": {
        "startTime": 294.656,
        "endTime": 299.694,
        "transcript": "Elitnauristet inerquraqluta takaryuusqevkenata.",
        "translation": "The teachers would admonish us against being withdrawn."
    },
    "43": {
        "startTime": 299.706,
        "endTime": 303.544,
        "transcript": "Maa-i tau͡gken takairulluteng.",
        "translation": "Now, however, they have no more sense of proper social conduct."
    },
    "44": {
        "startTime": 305.619,
        "endTime": 311.094,
        "transcript": "Qaillun tamakut elitnauristet takaryullren au͡g'avkangnaq'lallruaki?",
        "translation": "How did those teachers try to stop you from being withdrawn?"
    },
    "45": {
        "startTime": 311.388,
        "endTime": 318.838,
        "transcript": "Elitnaulallemteńi takaryuusqevkenata pilallruitkut",
        "translation": "When we used to go to school, they would tell us not to be withdrawn"
    },
    "46": {
        "startTime": 318.857,
        "endTime": 326.47,
        "transcript": "Amta-ll' wangkuta iciw' takaryutullruukut avani ciuqvani.",
        "translation": "Yet we would be withdrawn [by proper social conduct] a long time ago."
    },
    "47": {
        "startTime": 326.482,
        "endTime": 328.495,
        "transcript": "Maa-i tang takaryuyuirutellriit.",
        "translation": "You see, they lack proper social conduct now."
    },
    "48": {
        "startTime": 328.507,
        "endTime": 335.432,
        "transcript": "Tuar wiinga umyuarteqlemni takaryutulit assilriit, qigcigyugluteng ciunermeggnek.",
        "translation": "It seems, in my opinion, that those who hold themselves with proper social conduct are good, respecting everything before them."
    },
    "49": {
        "startTime": 335.438,
        "endTime": 343.813,
        "transcript": "Yuut-llu enemun itraqameng takaryugluteng uitaurluteng pilallruut-gguq. Yuum-gguq tau͡gaam kiavaasqaqateng kiavaraqluteng.",
        "translation": "And when people went into houses, they said they would stay put out of respect. Only when a person told them to come in would they come in."
    },
    "50": {
        "startTime": 343.832,
        "endTime": 349.294,
        "transcript": "Takaryutulit assirtut wiinga umyuarteqlemni.",
        "translation": "Those who hold themselves with proper social conduct are good in my opinion."
    },
    "51": {
        "startTime": 349.307,
        "endTime": 352.532,
        "transcript": "Takailnguut tau͡gken tua-i cali assirpek'nateng.",
        "translation": "Those without proper social conduct, however, are not good."
    },
    "52": {
        "startTime": 352.538,
        "endTime": 358.501,
        "transcript": "Tau͡gaam maa-i ayuqliulluteng takairutut elitnaurvigni caqtaaryaurcameng.",
        "translation": "But now, they all lack proper social conduct because they've started doing various things at school."
    },
    "53": {
        "startTime": 359.326,
        "endTime": 363.263,
        "transcript": "Camek, camek-mi tam' caqtaalallruceci elpeci?",
        "translation": "What kinds of various things would you do?"
    },
    "54": {
        "startTime": 363.276,
        "endTime": 368.313,
        "transcript": "Wangkuta tang elitnaullemni caqtaassiyaayuitellruukut.",
        "translation": "We, you see, when I went to school, we didn't do various things."
    },
    "55": {
        "startTime": 368.326,
        "endTime": 372.963,
        "transcript": "Elitnaurvingqerraallratni Nunapicuarmi elitnaullemni mikellruunga.",
        "translation": "When they first built a school in Nunapitchuk, I was small when I went to school."
    },
    "56": {
        "startTime": 372.976,
        "endTime": 375.626,
        "transcript": "Caqtaat enurnarqellruut.",
        "translation": "There was scarcely any various things to do."
    },
    "57": {
        "startTime": 376.395,
        "endTime": 384.733,
        "transcript": "Caqtaayuunata, angqayuunata, cayuunata, cheerlead-ayuunata.",
        "translation": "We didn't do various thigns, didn't play basketball, didn't do anything, didn' t cheerlead."
    },
    "58": {
        "startTime": 384.746,
        "endTime": 392.958,
        "transcript": "Maa-i iciw' takailnguut matarmeng-llu iruteng takaryugpek'nateng qaillun qetqertaqluteng-llu. Takaunateng tua-i.",
        "translation": "Now, you know, they have scant clothing, with no reservation about their legs, and they embrace. They have no reservations."
    },
    "59": {
        "startTime": 392.971,
        "endTime": 396.821,
        "transcript": "Wangkuta tamakut nallullruaput avani miklemteńi.",
        "translation": "We didn't know those back when we were small."
    },
    "60": {
        "startTime": 396.828,
        "endTime": 404.015,
        "transcript": "Qaillun aanarpet wall'u-qaa aulukutestevet wanigg', qaillun aulukutestevet...",
        "translation": "How did your mother, or your caretaker [\"aulukutestevet\"], how did your caretaker..."
    },
    "61": {
        "startTime": 404.565,
        "endTime": 406.09,
        "transcript": "\"Aulukestevet.\"",
        "translation": "\"Aulukestevet.\" [Your caretaker]"
    },
    "62": {
        "startTime": 406.109,
        "endTime": 414.784,
        "transcript": "Qaillun aulukestevet wanigg' yuucallruaten wanigg' nuliaqegtaarunaluten?",
        "translation": "How did your caretaker [?raise] you to be a good wife?"
    },
    "63": {
        "startTime": 415.103,
        "endTime": 423.678,
        "transcript": "Wiinga aulukesteḿa tuaten assirlua nulirqellerkamnek alerqullrunricaaqaanga",
        "translation": "My caretaker did not instruct me on how to be a good wife like that"
    },
    "64": {
        "startTime": 423.697,
        "endTime": 430.497,
        "transcript": "Tau͡gaam arnanek old-alrianek iliini qalarutaqatnga",
        "translation": "But when old women sometimes spoke to me"
    },
    "65": {
        "startTime": 430.504,
        "endTime": 439.479,
        "transcript": "Nalluama-wa tua-i elliraungama qalarut'lallruatnga qaillun assirlua nulirrullerkamnek, aanaullerkamnek irniamnun.",
        "translation": "Because I didn't know since I was an orphan, they would speak to me about how to be a good wife, and mother to my children."
    },
    "66": {
        "startTime": 439.498,
        "endTime": 441.285,
        "transcript": "Tamakunek elitellruunga.",
        "translation": "I learned from them."
    },
    "67": {
        "startTime": 441.298,
        "endTime": 443.048,
        "transcript": "Canek elissallruatgen?",
        "translation": "What did they teach you?"
    },
    "68": {
        "startTime": 443.217,
        "endTime": 453.892,
        "transcript": "Elicallruatnga aipaqa, nepaunanuk aipaqa-llu aipaqutellerkamegnek.",
        "translation": "They taught me that my spouse, that my spouse and I should be a peaceful couple."
    },
    "69": {
        "startTime": 454.586,
        "endTime": 464.211,
        "transcript": "Cali-llu irnianka anglicaqumki unuakuarmi unuakumi uiteqarraallratni qatpagatesqevkenaki.",
        "translation": "Also, if I raise my children, they told me not to shout at them when they first wake up in the morning."
    },
    "70": {
        "startTime": 466.792,
        "endTime": 469.005,
        "transcript": "Inerquutnguuq tamana.",
        "translation": "That is admonished against."
    },
    "71": {
        "startTime": 469.017,
        "endTime": 476.017,
        "transcript": "Irniaput-gguq qanpagacunaitaput unuakumi.",
        "translation": "They say we shouldn't shout at our children in the morning."
    },
    "72": {
        "startTime": 476.036,
        "endTime": 476.849,
        "transcript": "Ciin?",
        "translation": "Why?"
    },
    "73": {
        "startTime": 477.024,
        "endTime": 483.436,
        "transcript": "Tua-i-wa assinritlian. Kangiq'apiarii elisnganritaqa.",
        "translation": "Probably because it's not good. I don't know the exact meaning of it."
    },
    "74": {
        "startTime": 483.449,
        "endTime": 489.787,
        "transcript": "Man'a qalartelqa niitesqumayaaqaqa ayagyuanun.",
        "translation": "I want young people to hear what I've said."
    },
    "75": {
        "startTime": 489.8,
        "endTime": 497.8,
        "transcript": "Ayagyuarluteng qitevquralalriit maa-i. Taringenritaatnga-ll' tayima amlleret ayagyuat.",
        "translation": "They've started speaking mostly in English in their youth. And many young people probably don't understand me."
    },
    "76": {
        "startTime": 498.232,
        "endTime": 502.919,
        "transcript": "Ciin-gguq tamakut wanigg' aipaqellriit peggutetuat?",
        "translation": "Why do married couples get divorced?"
    },
    "77": {
        "startTime": 505.394,
        "endTime": 512.019,
        "transcript": "Ava-i man'a aipaqucaraq-gguq-qaa angtuaruuq.",
        "translation": "They say that being married is a big responsibility."
    },
    "78": {
        "startTime": 514.213,
        "endTime": 519.163,
        "transcript": "Tua-i-wa angtuaruluni, qigcignaqluni nulirqutlerkaq.",
        "translation": "Being married is a big responsibility and should be treated with respect."
    },
    "79": {
        "startTime": 519.182,
        "endTime": 529.107,
        "transcript": "Waten-gguq-qaa inerquutngullruuq-gguq-qaa aiparminek caunrilkiluni pisqevkenata.",
        "translation": "They said that disparaging one's spouse is admonished against like this."
    },
    "80": {
        "startTime": 529.201,
        "endTime": 537.463,
        "transcript": "Uika wiinga, uima-llu wiinga caunrillekńgaunii. Takaqevkenii piarkauvkenani.",
        "translation": "I [will not disparage] my husband, and my husband will not disparage me. He should not treat me with disrespect."
    },
    "81": {
        "startTime": 537.476,
        "endTime": 545.864,
        "transcript": "Caunrilkut'laryaaqukut tua-i qancurlagalluta camek assiitellriamek pikumta. Tua-i-gguq caunrilkuciiqukut.",
        "translation": "We do disparage each other when we harshly say something bad. They say that's how we disparage each other."
    },
    "82": {
        "startTime": 545.877,
        "endTime": 552.164,
        "transcript": "Tua-i-ll' atauciq-gguq tau͡gaam angtuaruuq caunrilkillerkaq aiparminek.",
        "translation": "Then they said that one is the greatest way to disparage one's spouse."
    },
    "83": {
        "startTime": 552.552,
        "endTime": 561.552,
        "transcript": "Angun, wall' arnaq uimi nalluakun anguciuquni, angutmun akusrarutekevquni",
        "translation": "A man, or if a women fools around with men without her husband's knowledge, if she lets a man fornicate with her"
    },
    "84": {
        "startTime": 561.571,
        "endTime": 564.421,
        "transcript": "Tua-i-gguq tauna angtuaq caunrilkilria.",
        "translation": "They say that's the greatest disparagement."
    },
    "85": {
        "startTime": 564.428,
        "endTime": 571.74,
        "transcript": "Wall'u angun nuliami nalluakuun allamek arnamek akusrarutekekuni",
        "translation": "Or if a man fornicates with another woman without his wife's knowledge"
    },
    "86": {
        "startTime": 571.753,
        "endTime": 574.153,
        "transcript": "Tua-i-gguq nuliaminek caunrilkiuq.",
        "translation": "They say he disparages his wife."
    },
    "87": {
        "startTime": 574.172,
        "endTime": 580.81,
        "transcript": "Tua-i-gguq taukuk angenkacagaullruuq aiparminek caunrilkiyaraq.",
        "translation": "They say those are the greatest ways to disparage one's spouse."
    },
    "88": {
        "startTime": 581.185,
        "endTime": 590.135,
        "transcript": "Camek cumiksugngaceta ayagyuani tamakunek icigg' taqsaramek, pinrilkurteńermek?",
        "translation": "What can we young people focus on to, you know, stop doing that, to keep from doing that?"
    },
    "89": {
        "startTime": 590.817,
        "endTime": 601.542,
        "transcript": "Tamakunek pinrilkurcukuni makut ak'allaraat niisngaarkaugait qanruyutait.",
        "translation": "If one wants to keep from doing those, they must listen to their ancient traditional wisdom."
    },
    "90": {
        "startTime": 601.873,
        "endTime": 611.936,
        "transcript": "Elitnaunge'rpet elitnaurvigmi caqtaarluteng puqigluten qaillun assirluten nulirrullerkan igausngangaicugnarquq.",
        "translation": "Even if you go to school where they do various things and you are smart, there probably won't be anything written about how you can be a good wife."
    },
    "91": {
        "startTime": 612.273,
        "endTime": 616.073,
        "transcript": "Wall' qaillun assirluten uingullerkan igausngangaituq.",
        "translation": "Or, there is nothing written about how you can be a good husband."
    },
    "92": {
        "startTime": 616.08,
        "endTime": 620.042,
        "transcript": "Elisngaqapiarang'e'rmi yuk elitnaurvigmi elisngaituq.",
        "translation": "Though a person is very smart, he will not learn in school."
    },
    "93": {
        "startTime": 620.055,
        "endTime": 630.818,
        "transcript": "Makunek tau͡gaam Yup'igni ciulirnernek wangkutnek, wiinga-llu ciulirnerunrilnge'rma waniwa ayuqucirtuagamci.",
        "translation": "But through these from our Yup'ik elders, and even though I am not an elder, I am instructing you now."
    },
    "94": {
        "startTime": 631.005,
        "endTime": 638.805,
        "transcript": "Assirluci nulirruyukuvci aipaci qigcikluki.",
        "translation": "If you want to be good wives, respect your spouses."
    },
    "95": {
        "startTime": 638.824,
        "endTime": 641.899,
        "transcript": "Wall' angutem nuliani qigcikluku.",
        "translation": "Or a man must respect his wife."
    },
    "96": {
        "startTime": 641.905,
        "endTime": 644.305,
        "transcript": "Allaliuyuunateng.",
        "translation": "Without committing adultery."
    },
    "97": {
        "startTime": 644.324,
        "endTime": 654.787,
        "transcript": "Allanek kenkiyuunateng, tua-i taumek tau͡gaam aiparminek aipangqerrarkauluni assirluni nulirruyulria wall' uinguyulria.",
        "translation": "One who wants to be a good wife or husband will not \"love\" others, but will be married to their spouse."
    },
    "98": {
        "startTime": 656.974,
        "endTime": 658.474,
        "transcript": "Maa-i tau͡gaam...",
        "translation": "But now..."
    },
    "99": {
        "startTime": 658.768,
        "endTime": 664.918,
        "transcript": "Au͡gna-qaa apyutkan qaillun-llu assiinani nulirrullerkam, uingullerkam?",
        "translation": "Did you ask about how to be a bad wife or husband?"
    },
    "100": {
        "startTime": 665.887,
        "endTime": 674.412,
        "transcript": "Yuk assiinani nulirrukuni wall' uingukuni aiparminek qigcikivkenani.",
        "translation": "If a person is a bad wife or husband, they will not respect their spouse"
    },
    "101": {
        "startTime": 674.418,
        "endTime": 680.931,
        "transcript": "Allanek allaliulaquni-gguq taukuk-gguq nulirqellriik quyungqangaituk.",
        "translation": "They said that if one fornicates with others, that married couple will not be together."
    },
    "102": {
        "startTime": 682.781,
        "endTime": 686.881,
        "transcript": "Iciw' inerquutnguuq man'a.",
        "translation": "You know, this is admonished against."
    },
    "103": {
        "startTime": 686.888,
        "endTime": 692.35,
        "transcript": "Amlleret inerquutet niicuitait maa-i mat'um nalliini.",
        "translation": "Many do not heed admonishments these days."
    },
    "104": {
        "startTime": 692.351,
        "endTime": 697.276,
        "transcript": "Amlleqapiartut. Carraq tamarmi inerquutengqelliniuq.",
        "translation": "There is a multitude. Every little thing has admonishments."
    },
    "105": {
        "startTime": 697.745,
        "endTime": 707.307,
        "transcript": "Iciw' tua-i maligtaqutelleq assilriamun, tua-i inerquutet aturpek'nani assilria maligtaqukuniu.",
        "translation": "You know, if they follow good [advice], they will not do what is admonished against if they follow good [advice]."
    },
    "106": {
        "startTime": 710.92,
        "endTime": 718.445,
        "transcript": "Qanellrulriaten icigg' kenkutevkenatek wanigg' uin-llu ayagnillrulriatek.",
        "translation": "You know how you said that you and your husband started off not loving each other?"
    },
    "107": {
        "startTime": 718.451,
        "endTime": 721.976,
        "transcript": "Cam kenkutngiinavkallruatek?",
        "translation": "What caused your love for each other to grow?"
    },
    "108": {
        "startTime": 722.82,
        "endTime": 725.107,
        "transcript": "Wiinga tang...",
        "translation": "You see, I..."
    },
    "109": {
        "startTime": 726.295,
        "endTime": 731.007,
        "transcript": "Wiinga uikamnek wangnek choose-allrunritua.",
        "translation": "I didn't choose my own husband."
    },
    "110": {
        "startTime": 731.72,
        "endTime": 734.695,
        "transcript": "Aulukesteḿa choose-autellruanga.",
        "translation": "My caretaker chose for me."
    },
    "111": {
        "startTime": 734.701,
        "endTime": 743.501,
        "transcript": "Avani-wa qigcikutellruameng yuut takaqulluteng, camun kenekngiinalqa nallukeka.",
        "translation": "Because people respected and deferred to each other, I don't know what made my love grow."
    },
    "112": {
        "startTime": 743.895,
        "endTime": 751.233,
        "transcript": "Tau͡gaam maligtaquurluki aipaput pisqetullrukait assirluta aipauyukumta.",
        "translation": "But they told us to work in accordance with our spouses if we want to be good spouses."
    },
    "113": {
        "startTime": 755.583,
        "endTime": 759.221,
        "transcript": "Qusqatayangiiqerpakar.",
        "translation": "I've been on the verge of coughing."
    },
    "114": {
        "startTime": 761.671,
        "endTime": 769.221,
        "transcript": "Camek cumikellerpeni uivnek, camek assikisit uivni?",
        "translation": "As you watched your husband, what do you like about your husband?"
    },
    "115": {
        "startTime": 770.84,
        "endTime": 772.64,
        "transcript": "Aulukillemni?",
        "translation": "When I took care of them?"
    },
    "116": {
        "startTime": 772.847,
        "endTime": 778.734,
        "transcript": "Wiinga uika cumikellemni, wall' uikellemni",
        "translation": "As I watched my husband, or as he was my husband"
    },
    "117": {
        "startTime": 778.747,
        "endTime": 788.072,
        "transcript": "Assikaqa takaqulluta atunem pillerput, caunrilkutevkenata.",
        "translation": "I like that we treat each other with mutual respect, not disparaging each other."
    },
    "118": {
        "startTime": 788.928,
        "endTime": 798.753,
        "transcript": "Uima-llu caliyaurpailegmi pissulallrani ellma pitai aulukaqluki assingnaqluki",
        "translation": "And before my husband started working, I would try to take good care of what little he caught"
    },
    "119": {
        "startTime": 798.997,
        "endTime": 803.197,
        "transcript": "Pitat-wa tua-i animal-aat.",
        "translation": "The animals he had caught."
    },
    "120": {
        "startTime": 806.816,
        "endTime": 818.129,
        "transcript": "Maa-i umyuartequten-qaa peggutellriit makut ilait ilaumaut-qaa taangiq'lallermeng wall'u-qaa kemninarqellriatnek atulallratnek?",
        "translation": "In your opinion, are some of the people who get divorced now include those who abuse alcohol or other mind-altering substances?"
    },
    "121": {
        "startTime": 818.341,
        "endTime": 829.341,
        "transcript": "Yaa, maa-i tamaa-i tamana au͡gna qalartelqa ciuqliq assilria yugni piciryaralqaat.",
        "translation": "Yes, the good thing that I just talked about at first was what people practiced."
    },
    "122": {
        "startTime": 829.36,
        "endTime": 834.173,
        "transcript": "Maa-i tau͡gken pegutelallrat",
        "translation": "Now, however, how they get divorced"
    },
    "123": {
        "startTime": 836.61,
        "endTime": 843.448,
        "transcript": "Elluatuunrirluteng ayagyuat ellaita cucukellermeggnek uingelaameng",
        "translation": "The young people are no longer doing right because they take husbands they've chosen themselves"
    },
    "124": {
        "startTime": 843.461,
        "endTime": 848.598,
        "transcript": "Parent-aarita cucukutevkenaki ellmeggnek nulirqut'laameng.",
        "translation": "Because their parents don't choose for them, and they take wives they choose."
    },
    "125": {
        "startTime": 848.611,
        "endTime": 859.873,
        "transcript": "Tamaa-i-llu avuutelallrat ellaita piyullermeggnek piluteng parent-aateng ataneqevkenaki.",
        "translation": "They reason for their getting divorced is because they [marry] whom they want, not deferring to their parents."
    },
    "126": {
        "startTime": 859.886,
        "endTime": 861.711,
        "transcript": "Man'a-mi taangaq?",
        "translation": "What about this alcohol?"
    },
    "127": {
        "startTime": 861.717,
        "endTime": 868.705,
        "transcript": "Taangaq-llu man'a murilkellemni ukaqvaggun taangaq amlleriuq.",
        "translation": "About this alcohol, in my observation, there has recently been an increase in alcohol."
    },
    "128": {
        "startTime": 868.718,
        "endTime": 876.88,
        "transcript": "Nulirqellriik, nulirqellriik uinga taangatukuni, nulirra-llu taangiqsuunani",
        "translation": "For married couples, if her husband drinks alcohol, and his wife doesn't drink alcohol"
    },
    "129": {
        "startTime": 877.243,
        "endTime": 882.731,
        "transcript": "Nulirran unaksuumaa assirivkarluku uini.",
        "translation": "His wife wants her husband to get better."
    },
    "130": {
        "startTime": 883.994,
        "endTime": 889.419,
        "transcript": "Uini-wa taqevkangnaqluku taangiq'lallranek.",
        "translation": "She tries to have her husband stop abusing alcohol."
    },
    "131": {
        "startTime": 889.8,
        "endTime": 896.788,
        "transcript": "Yuk, arnaq, yuk Agayutmek nalluvkenani piicatukuni",
        "translation": "If a person, a woman, a person knows God and prays"
    },
    "132": {
        "startTime": 896.801,
        "endTime": 901.576,
        "transcript": "Agayutem niiciiqaa piyullranek, uinga-llu taangayuirulluni.",
        "translation": "God will hear her desire, and her husband will stop drinking alcohol."
    },
    "133": {
        "startTime": 901.682,
        "endTime": 913.195,
        "transcript": "Wall'u-wa nulirqellriik uinga taangatukuni, nulirra-llu taangayuiqaarluni uini aipingkuniu tua-i-llu taukuk navgullutek.",
        "translation": "Or in a married couple if her husband drinks alcohol, and the wife joins her husband after she didn't drink, they will destroy themselves."
    },
    "134": {
        "startTime": 913.52,
        "endTime": 918.432,
        "transcript": "Navgullutek, nakukucuglutek, avvullutek-llu tua-i.",
        "translation": "They destroy each other, fight each other, then get a divorce."
    },
    "135": {
        "startTime": 920.908,
        "endTime": 929.645,
        "transcript": "Elitaqkaniuk-mi navgurillrak elliik taukuk tamarmek taangiqaqamek, qaillun piyugngaak?",
        "translation": "If they understand that they're destroying each other if they both drink alcohol, what can they do?"
    },
    "136": {
        "startTime": 929.658,
        "endTime": 935.833,
        "transcript": "Icigg' taukuk ellanglutek ellmegnek wanigg' navguutnilutek.",
        "translation": "You know, if they realize that they're destroying each other."
    },
    "137": {
        "startTime": 936.789,
        "endTime": 945.914,
        "transcript": "Makut-wa maa-i nallunrilngukut taangayuirut'lalriit iciw' kitugiluteng-ll' assiriluteng.",
        "translation": "Now, we know that they stop drinking alcohol, you know, fix themselves and get better."
    },
    "138": {
        "startTime": 945.933,
        "endTime": 953.958,
        "transcript": "Ellmeggnek taringluteng nulirqellriit taangatukuneng ellmeggnek taringekuneng",
        "translation": "If married couples who drink alcohol understand themselves, understand their [situations]"
    },
    "139": {
        "startTime": 953.964,
        "endTime": 963.964,
        "transcript": "Man'a ellaita alaruteteng taangaq pegcungluku pegeskunegteggu tamaaggun pegciyugngaut.",
        "translation": "If they give up their abuse of alcohol when they want to, they can give it up through that."
    },
    "140": {
        "startTime": 963.983,
        "endTime": 968.483,
        "transcript": "Pisciigalngurtaituq. Piyugngaut cat tamarmeng.",
        "translation": "There is no one who can't. Anything can be done."
    },
    "141": {
        "startTime": 969.39,
        "endTime": 976.702,
        "transcript": "Taangiq'lallermek-mi tamakut mikelnguut aknirtellriit umyuaratgun wall'u-qaa ircaquatgun",
        "translation": "What about the children who were hurt in their minds or hearts when [the parents] drank alcohol"
    },
    "142": {
        "startTime": 976.715,
        "endTime": 985.265,
        "transcript": "Taqkateng-llu taukut cali mikelnguut umyuarat wall'u-q' ircaquat navgumartulriit qaillun kitugcugngaa?",
        "translation": "When when they stop, how can the broken mental health or hearts of those children be fixed?"
    },
    "143": {
        "startTime": 988.009,
        "endTime": 1002.197,
        "transcript": "Taangiqtulit-wa makut taangiqaqameng-wa irniarit akngiringatuyugnarqut qamaggun cakneq iluqvaggun.",
        "translation": "When these alcoholics are drunk, their children are probably hurt very deep inside."
    },
    "144": {
        "startTime": 1002.585,
        "endTime": 1007.56,
        "transcript": "Angayuqat makut tamana atunriqunegteggu",
        "translation": "If these parents stop doing that"
    },
    "145": {
        "startTime": 1007.566,
        "endTime": 1019.891,
        "transcript": "Irniateng, umyuarnaayaguciluteng-wa tua-i irniateng assirluki aulukekunegteki elluarivkangnaqluki",
        "translation": "Their children, well, if they start having the mind to take good care of their children to make them better"
    },
    "146": {
        "startTime": 1019.91,
        "endTime": 1025.61,
        "transcript": "Iciw' ak'arnun tamana akngiru[?]ciqsugnarquq yuum ircaqu͡rani.",
        "translation": "You know, that will probably be a long-standing hurt in a person's heart."
    },
    "147": {
        "startTime": 1026.254,
        "endTime": 1032.179,
        "transcript": "Tau͡gaam mamevkangnaqkuneng mam'iciqut.",
        "translation": "But if they try to heal, they will heal."
    },
    "148": {
        "startTime": 1034.148,
        "endTime": 1041.798,
        "transcript": "Kiingan-qaa tua-i taukuk taangiqtullrek wanigg' ircaqu͡rakun calikagnek?",
        "translation": "You mean only if those two who were alcoholics worked with their hearts?"
    },
    "149": {
        "startTime": 1042.192,
        "endTime": 1052.842,
        "transcript": "Yaa, taangiqtulik-wa maa-i-wa matum nalliini taangatulit-llu iciw' ikayurtengelriit maani?",
        "translation": "Yes, the alcoholic [parents] these days, you know how alcoholics have help here now?"
    },
    "150": {
        "startTime": 1052.861,
        "endTime": 1058.661,
        "transcript": "Ikayurteḿegteggun ikayurluteng assiriyugngaut.",
        "translation": "They can get better with the help of their counselors."
    },
    "151": {
        "startTime": 1058.93,
        "endTime": 1070.755,
        "transcript": "Nulirqellriik-llu, amllernek tanglartua assilrianek nulirqellrianek, kenkitarluteng-llu irniameggnek.",
        "translation": "And married couples, I see many who are in good marriages, and they love their children."
    },
    "152": {
        "startTime": 1071.599,
        "endTime": 1079.374,
        "transcript": "Tamatum tau͡gaam ataucim mat'um maa-i nalliini arcaqerluki navgungai nulirqellriit.",
        "translation": "But that one thing is the worst thing that destroys married couples these days."
    },
    "153": {
        "startTime": 1079.668,
        "endTime": 1086.855,
        "transcript": "Taangiqaqameng iciw' yuut tangvalaqeput tua-i piciatun pilalriit, takaryugpek'nateng-llu.",
        "translation": "When they're drunk, you know we watch them doing unacceptable things, and they have no self-restraint."
    },
    "154": {
        "startTime": 1086.868,
        "endTime": 1090.743,
        "transcript": "Uumek-llu arnamek qaillun piaqluteng kenkuuriluteng",
        "translation": "And they do things with this woman, \"loving\" others."
    },
    "155": {
        "startTime": 1090.762,
        "endTime": 1093.424,
        "transcript": "Tua-i-wa takaircameng.",
        "translation": "Because they have no more self-restraint."
    },
    "156": {
        "startTime": 1094.362,
        "endTime": 1107.875,
        "transcript": "Tamakut pegcikuneng ircaqumegteggun ukverluteng, ircaqumegteggun pegcikuneng assiriyugngaut.",
        "translation": "If those people give it up, believing with their hearts, if they give it up in their hearts, they can get better."
    },
    "157": {
        "startTime": 1108.325,
        "endTime": 1114.137,
        "transcript": "Assinrurcugngaut-llu wangkutni taangiqeksailengramta yuullerni.",
        "translation": "And they can become better than us who have never drunk alcohol in our lives."
    },
    "158": {
        "startTime": 1115.325,
        "endTime": 1125.0,
        "transcript": "Ak'a tamaani wanigg' peggutengyaurtellermeng, cat makut tegganret pilallruaki tamakut peggutellrek?",
        "translation": "When couples separated a long time ago, what would these elders do or say to those who separated?"
    },
    "159": {
        "startTime": 1125.219,
        "endTime": 1127.481,
        "transcript": "Qaillun pilallruaki?",
        "translation": "What did they say to them?"
    },
    "160": {
        "startTime": 1127.494,
        "endTime": 1131.382,
        "transcript": "Wiinga tang tua-i ak'a tamaani elisngassiyaanrilkeka.",
        "translation": "You see, I'm not too knowledgeable about the distant past."
    },
    "161": {
        "startTime": 1131.395,
        "endTime": 1141.457,
        "transcript": "Tau͡gaam wiinga ellangellruunga nulirqellriit tua-i nulirqutaqluteng, pegusngacuunateng-llu.",
        "translation": "But when I was growing up, married couples were married couples, and they didn't seem to separate."
    },
    "162": {
        "startTime": 1141.47,
        "endTime": 1144.558,
        "transcript": "Tuar tang wangni pegusngacuilnguut.",
        "translation": "They didn't seem to separate to me."
    },
    "163": {
        "startTime": 1144.571,
        "endTime": 1154.758,
        "transcript": "Iciw' qigcikulluteng cat makut amllerivailgata yuuqcaaralallruukut nunarrarni assirluta.",
        "translation": "You know, they respected each other before these [Western things] became a lot, and we lived well in little villages."
    },
    "164": {
        "startTime": 1154.771,
        "endTime": 1160.783,
        "transcript": "Caarkalirpek'nata-llu maani enem iluani, tua-i-wa eneput mikngata.",
        "translation": "And we didn't have a lot to do here in the house because our houses were small."
    },
    "165": {
        "startTime": 1161.159,
        "endTime": 1163.771,
        "transcript": "Caarkalirpek'nata.",
        "translation": "We didn't have a lot to do."
    },
    "166": {
        "startTime": 1165.272,
        "endTime": 1167.684,
        "transcript": "Allamek cali qanerkaituten?",
        "translation": "Do you have anything else to say?"
    },
    "167": {
        "startTime": 1169.272,
        "endTime": 1171.11,
        "transcript": "Arcaqalriamek wall'u-qaa?",
        "translation": "Anything important or what?"
    },
    "168": {
        "startTime": 1171.123,
        "endTime": 1182.748,
        "transcript": "Arcaqalriamek wiinga qanerkangqertua maa-i-wa yuut navguutiitnek.",
        "translation": "I have something important to say about what brings people to destruction."
    },
    "169": {
        "startTime": 1184.754,
        "endTime": 1195.042,
        "transcript": "Assirluni yuk yuuyukuni angayuqaagminek niisngailuni, niisngallermikun assirluni yuuyugngauq.",
        "translation": "If a person wants to live well, he can live well by obeying his parents."
    },
    "170": {
        "startTime": 1195.205,
        "endTime": 1201.592,
        "transcript": "Angayuqaulriani irniaput waten alerqurngaitaput:",
        "translation": "We parents will not instruct our children like this:"
    },
    "171": {
        "startTime": 1201.605,
        "endTime": 1206.217,
        "transcript": "\"Ankuvet assiinak pikina.\" Nuu, tamakunek pingaitaput.",
        "translation": "\"When you go out, be bad.\" No, we will not tell them that."
    },
    "172": {
        "startTime": 1206.23,
        "endTime": 1211.743,
        "transcript": "Irniaput assirluki tamalkuita pisqumalaraput.",
        "translation": "We want all of our children to be good."
    },
    "173": {
        "startTime": 1211.755,
        "endTime": 1220.58,
        "transcript": "Cali-llu makut maa-i ayagyuat nulirqutellriit mat'um nalliini",
        "translation": "Also, these young people who are getting married these days"
    },
    "174": {
        "startTime": 1222.011,
        "endTime": 1231.636,
        "transcript": "Uiteng, wall'u-w' angutem nuliani wall'u arnam uini takaqenritsiyaallrata navgutuit.",
        "translation": "Their husbands, or when a man has too little respect for his wife, or a woman her husband, it destoys them."
    },
    "175": {
        "startTime": 1231.642,
        "endTime": 1236.642,
        "transcript": "Caunrillekluki, ellait angenrurrluteng.",
        "translation": "They disparage themselves, making themselves more important."
    },
    "176": {
        "startTime": 1236.661,
        "endTime": 1240.949,
        "transcript": "Waten wiinga niitelallruunga uingellemni:",
        "translation": "I used to hear this when I took a husband:"
    },
    "177": {
        "startTime": 1240.962,
        "endTime": 1251.249,
        "transcript": "Uiput-gguq, uiput-gguq ikiungraata, wall' tussitengraata, qaill' ayuqengraata takaqerkaugaput caunrilkevkenaki.",
        "translation": "They said that even if our husbands are ugly, or walk with a limp, no matter what they're like, we must respect them and not disparage them."
    },
    "178": {
        "startTime": 1251.262,
        "endTime": 1256.812,
        "transcript": "Mat'um nalliini nulirqutellriit elluatuunrillrat",
        "translation": "The reason that married couples are no longer good these days"
    },
    "179": {
        "startTime": 1256.819,
        "endTime": 1263.319,
        "transcript": "Ellmeggnek-llu uikameggnek cucuklirluteng uingluteng ayuquciit yuvrirpek'naki",
        "translation": "They choose and take their own husbands without examining their characters first"
    },
    "180": {
        "startTime": 1263.326,
        "endTime": 1270.488,
        "transcript": "Kegginaqegcillran, kegginaq tangniqellran pivkarluku, ayuquciit tau͡gken assiitelliniluteng.",
        "translation": "They do that because they have pretty faces, yet their characters are bad."
    },
    "181": {
        "startTime": 1270.501,
        "endTime": 1275.401,
        "transcript": "Tamakut elluarrluki nulirqucecuitait.",
        "translation": "That's what makes them have rocky marriages."
    },
    "182": {
        "startTime": 1275.42,
        "endTime": 1287.858,
        "transcript": "Avani alerqutullrulliniit, yuk-gguq kegginarrliqengraan, kegginaa ikiungraan uikesqelluku, elluarrluku taumun aulukciqniluku.",
        "translation": "They apparently used to instruct them a long time ago, to marry a person even if he has an ugly face, saying that he will take care of her well."
    },
    "183": {
        "startTime": 1287.871,
        "endTime": 1289.433,
        "transcript": "Cunaw' piciuluni.",
        "translation": "It turned out to be true."
    },
    "184": {
        "startTime": 1289.446,
        "endTime": 1300.196,
        "transcript": "Maa-i nulirqellriit uimeggnek caunrilkissiyaallrata wall' uumek tan'gaurlurmek caunrilkillrata elluatuunrircetait.",
        "translation": "Now, because married couples disparage their husbands too much, or they disparage this boy, they are not good anymore."
    },
    "185": {
        "startTime": 1300.203,
        "endTime": 1305.578,
        "transcript": "Makut qanruyutet niicuilamegteki nalluut.",
        "translation": "Because they don't hear these pieces of traditional wisdom, they don't know."
    },
    "186": {
        "startTime": 1306.559,
        "endTime": 1314.097,
        "transcript": "Mikelnguq mikelria an'aqami aanagminek elitnauryaurtaqami",
        "translation": "When a small child goes out from his parents' when he starts going to school"
    },
    "187": {
        "startTime": 1314.11,
        "endTime": 1318.397,
        "transcript": "Ernerpall'er cataitelartuq, unuan-llu uterrluni-llu taqsuqluni.",
        "translation": "He's gone all day long, then goes home tired at night."
    },
    "188": {
        "startTime": 1318.41,
        "endTime": 1322.935,
        "transcript": "Tua-i angayuqaagminek amllermek elitesciiganani.",
        "translation": "He can't learn much from his parents."
    },
    "189": {
        "startTime": 1322.941,
        "endTime": 1324.916,
        "transcript": "Elitnaurvigglainarkun...",
        "translation": "Only through school..."
    }
};